import { lazy } from 'react';

export const PlayerKycStatusForm = lazy(() => import('./PlayerKycStatusForm'));
